import { render, staticRenderFns } from "./TutorialDetail.vue?vue&type=template&id=0a368aa2&"
import script from "./TutorialDetail.vue?vue&type=script&lang=js&"
export * from "./TutorialDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports